import { BillingTaskHours } from '../../../models/billing-history.models';
import { RowExpansion } from '../row-expansion/row-expansion';

/** The shape both billing tables' rows share, as far as the expander is concerned. */
interface ExpandableRow {
  taskSummary?: BillingTaskHours[] | null;
}

/**
 * The billing cards' task-breakdown expander: a {@link RowExpansion} bound to the billing row
 * shape. Which rows are open, their panel ids and the count label all live in the base class;
 * this only supplies what a billing row counts and what those items are called.
 *
 * Kept as its own type rather than inlined at the two call sites so the counting rule and the
 * panel-id prefix stay in one place — both billing cards render together on a matter page.
 */
export class TaskBreakdownExpansion<
  TRow extends ExpandableRow,
> extends RowExpansion<TRow> {
  constructor() {
    // Counting the untasked bucket keeps the label in step with the panel, which lists it like
    // any other line. Zero covers two different rows: one the feed said nothing about, and one
    // it said had no task time. Both still open to a single explanatory line, so the count is a
    // preview of the task buckets rather than of every line the panel can render.
    super((row) => row.taskSummary?.length ?? 0, 'task', 'task-breakdown-panel');
  }
}
